

import {
    Component,
    OnInit,
  } from "@angular/core";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { arrayUnion, updateDoc } from "firebase/firestore";
  import { NGXLogger } from "ngx-logger";
  import { MenuItem, MessageService } from "primeng/api";
  
  import {
    DynamicDialogConfig,
    DynamicDialogRef,
  } from "primeng/dynamicdialog";
  import { Subject } from "rxjs";
import { PreventivoFase1DTO } from "src/app/models/dto/preventivoFase1.model";
import { SopralluogoFase1DTO } from "src/app/models/dto/sopralluogoFase1.model";
import { PraticaFlowdy2_Firestore } from "src/app/models/praticaFirestore.model";
import { GoogleStorageService } from "src/app/services/googleStorage.service";
import { PraticheScuolaService } from "src/app/services/pratiche.scuola.service";
import { PraticheService } from "src/app/services/pratiche.service";
import { environment } from "src/environments/environment";

  

@Component({
    selector: "component-carica-altri-file",
    templateUrl: "./dialog-carica_altri_file.component.html",
    styleUrls: ["../shared.component.css"],
  })
  export class DialogCaricaAltriFile implements OnInit {
    protected _onDestroy = new Subject<void>();
    protected pratica: PraticaFlowdy2_Firestore;
    protected tipoFile:String="";
    
    protected file: File;
    protected files: File[]=[];
    protected isUploadingFile:boolean = false;
    
    protected label:string="Cerca file";
    protected icona:string="";
    protected stile:string="btn-choose-file-fase2";
    protected fileClass:string="btn-choose-file-fase2";
    protected acceptedFileTypes:string=".pdf, .p7m, .jpg,, .jpeg, .png";

    private collection_pratiche:string = environment.firebase.collection_pratiche;


    constructor(
      private logger: NGXLogger,
      public dialogRef: DynamicDialogRef,
      public config: DynamicDialogConfig,
      private googleStorageService: GoogleStorageService,
      private messageService: MessageService,
      private formBuilder: FormBuilder,
      public firestore: AngularFirestore,
    ) {
      this.pratica          = this.config.data.pratica;
      this.tipoFile         = this.config.data.tipoFile;
     
      
      
    }
  
    ngOnInit(): void {
    }

    onFileUpload($event){

    }

    onFileSelect($event: { files: File[]; }) {
      if($event.files.length>1){
        this.label = $event.files.length + ' files caricati';
      }else{
        this.label = 'File caricato';
      }
      
     
     
      this.icona = "pi pi-check";
      this.fileClass = "btn-file-fase2-upload-success";
      this.file = $event.files[0];
      this.files = Array.from($event.files); 
     
    }  

   
    conferma(conferma: boolean) {
      if (!conferma) {
        this.dialogRef.close({ success: false });
      } else {
        if (this.files.length === 0) {
          this.messageService.add({
            severity: "warn",
            summary: "Attenzione",
            life: 10000,
            detail: "Nessun file selezionato!",
          });
          return;
        }

        this.isUploadingFile = true;
        
        // Array per tenere traccia dei promise di upload
        const uploadPromises: Promise<any>[] = [];
        
        // Creo un promise per ogni file da caricare
        this.files.forEach((file, index) => {
          const fileName = this.pratica.cui + "/IN/FASE_3/altro/" + file.name;
          const uploadPromise = this.googleStorageService
            .uploadFileScuolaToGoogleStorage(file, fileName);
          uploadPromises.push(uploadPromise);
        });

        // Eseguo tutti gli upload in parallelo
        Promise.allSettled(uploadPromises)
          .then((results) => {
            const successfulUploads = results.filter(result => result.status === 'fulfilled').length;
            const failedUploads = results.filter(result => result.status === 'rejected').length;
            
            if (successfulUploads > 0) {
              this.pratica.fileAltriUploadedFase3 = true;
              const docRef = this.firestore.collection(this.collection_pratiche).doc(this.pratica.cui);

              docRef.update(this.pratica)
                .then(() => {
                  this.isUploadingFile = false;
                  
                  
                  this.dialogRef.close({ 
                    success: true, 
                    filesUploaded: successfulUploads,
                    filesFailed: failedUploads,
                    totalFiles: this.files.length
                  });
                })
                .catch((error) => {
                  this.isUploadingFile = false;
                  this.messageService.add({
                    severity: "error",
                    summary: "Errore",
                    life: 10000,
                    detail: "Errore in fase di aggiornamento della pratica dopo il caricamento dei file di " + this.tipoFile + "!",
                  });
                  
                  this.dialogRef.close({ success: false });
                });
            } else {
              // Tutti gli upload sono falliti
              this.isUploadingFile = false;
              this.messageService.add({
                severity: "error",
                summary: "Errore",
                life: 10000,
                detail: "Errore: nessun file è stato caricato con successo!",
              });
              
              this.dialogRef.close({ success: false });
            }
          })
          .catch((error) => {
            this.isUploadingFile = false;
            this.messageService.add({
              severity: "error",
              summary: "Errore",
              life: 10000,
              detail: "Errore generale in fase di caricamento dei file!",
            });

            this.dialogRef.close({ success: false });
          });
      } 
    }
  
  }